import WebProvider from "./WebProvider";

const BreakoutRoomsProvider = new WebProvider();

export default BreakoutRoomsProvider;
